import {faArrowDownToBracket} from '@netx/core-icons';
import {type ReactAction} from '@netx/core/bootstrap';
import {canDownloadAssetView} from '../enablers';
import {AssetViewActionLabel} from '../locales';
import {type IAsset} from '@netx/core-asset-next/schema';
import {type IAssetView} from '../schema';

export const assetViewActionDownloadIcon = faArrowDownToBracket;

export interface AssetViewActionDownloadParams extends Partial<ReactAction> {}

/**
 * Download asset view
 * @param params
 * @returns Action
 */
export const assetViewActionDownload = (
	asset: IAsset,
	view: IAssetView,
	params: AssetViewActionDownloadParams = {},
): ReactAction => ({
	name: 'asset-view-download',
	cb: () => {},
	enableTest: () => canDownloadAssetView(asset, view),
	icon: assetViewActionDownloadIcon,
	get label() {
		return AssetViewActionLabel.DOWNLOAD;
	},
	...params,
});
